declare global {
  interface Window {
    /**
     * For asynchronous tracking, configuration and tracking calls are pushed onto the global _paq array for execution, independent of the asynchronous loading of matomo.js. The format is: `_paq.push([ 'API_method_name', parameter_list ]);`
     * @see {@link https://developer.matomo.org/guides/tracking-javascript-guide}
     */
    _paq: any[];
  }
}

export const matomoTracking = () => {
  /** Setup Matomo event layer */
  if (!window._paq) window._paq = [];

  // The following code is from https://matomo.org/faq/how-to/using-cookiebot-consent-manager-with-matomo/ (converted from Vanilla JS to TypeScript by @wanjakarl)

  let waitForTrackerCount = 0;

  const matomoWaitForTracker = () => {
    if (
      typeof window._paq === 'undefined' ||
      typeof window.Cookiebot === 'undefined'
    ) {
      if (waitForTrackerCount < 40) {
        setTimeout(matomoWaitForTracker, 250);
        waitForTrackerCount++;
        return;
      }
    } else {
      window.addEventListener('CookiebotOnAccept', () => {
        consentSet();
      });

      window.addEventListener('CookiebotOnDecline', () => {
        consentSet();
      });
    }
  };

  const consentSet = () => {
    if (window.Cookiebot.consent.statistics) {
      window._paq.push(['setCookieConsentGiven']);
      window._paq.push(['setConsentGiven']);
    } else {
      window._paq.push(['forgetCookieConsentGiven']);
      window._paq.push(['forgetConsentGiven']);
    }
  };

  document.addEventListener('DOMContentLoaded', matomoWaitForTracker);

  // The following code was provided by the client in https://app.asana.com/0/1204759196258487/1206183240847184/f and modified by us (we moved the loading of the matomo.js script outside the scope to work with the DSGVO requirements)

  /* tracker methods like "setCustomDimension" should be called before "trackPageView" */
  window._paq.push(['requireCookieConsent']);
  window._paq.push(['trackPageView']);
  window._paq.push(['enableLinkTracking']);

  (function () {
    const u = 'https://stadtwerkehilden.matomo.cloud/';
    window._paq.push(['setTrackerUrl', u + 'matomo.php']);
    window._paq.push(['setSiteId', '1']);
  })();
};
